import { cx } from "class-variance-authority";
import type { ReactElement } from "react";
import { ErrorBannerText } from "./ErrorBannerText";

export interface ErrorBannerProps {
  className?: string;
  error: any;
}
export function ErrorBanner({
  error,
  className,
}: ErrorBannerProps): ReactElement | null {
  if (!error) {
    return null;
  }
  return (
    <div
      role="alert"
      aria-live="polite"
      className={cx("rounded bg-red-100 px-5 py-3 text-red-700", className)}
    >
      <ErrorBannerText error={error} />
    </div>
  );
}
